import reactComponentLoader from 'scripts/react-component-loader'

import Chatbot from './Chatbot'

reactComponentLoader(Chatbot, '[data-lmcv-chatbot]')
